import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import school from "../assets/icons/school-01.png";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  return (
    <footer className="bg-[#005064] text-white relative">
      <div className="bottom-0 left-0 z-0 absolute w-1/4">
        <img src={school} alt="" className="" />
      </div>
      <div className="grid lg:grid-cols-2 xl:gap-20 gap-10 xl:max-w-screen-xl w-11/12 mx-auto py-20 z-[2] isolate">
        {/* Left Section */}
        <div className="lg:w-4/5">
          <h2 className="md:text-3xl text-2xl font-bold mb-6">
            SLN Educational Society
          </h2>

          <p className="text-white text-base text-justify xl:w-4/5 ">
            SLN Educational Society shapes future-ready generations through its
            K–12 international school built on the foundations of compassion,
            character and holistic development. Here curiosity drives learning,
            global perspectives expand horizons and every child is valued for
            who they are beyond academic achievement.
          </p>
        </div>

        {/* Right Section */}
        <div className="grid sm:grid-cols-2 gap-10">
          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Quick Links</h3>

            <ul className="space-y-2 text-base">
              <li>
                <a
                  href="/"
                  className="flex items-center gap-2 hover:text-[#D4E9EF] transition"
                >
                  <ArrowForwardIcon size={16} />
                  Home
                </a>
              </li>

              <li>
                <HashLink
                  to="/#about-us"
                  className="flex items-center gap-2 hover:text-[#D4E9EF] transition"
                >
                  <ArrowForwardIcon size={16} />
                  About
                </HashLink>
              </li>

              <li>
                <a
                  href="/#our-team"
                  className="flex items-center gap-2 hover:text-[#D4E9EF] transition"
                >
                  <ArrowForwardIcon size={16} />
                  Team
                </a>
              </li>

              <li>
                <a
                  href="/#our-mission"
                  className="flex items-center gap-2 hover:text-[#D4E9EF] transition"
                >
                  <ArrowForwardIcon size={16} />
                  Mission
                </a>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="flex items-center gap-2 hover:text-[#D4E9EF] transition"
                >
                  <ArrowForwardIcon size={16} />
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Contact Info</h3>

            <div className="space-y-5">
              <div className="flex gap-3">
                <LocationOnOutlinedIcon
                  size={20}
                  className="mt-1 flex-shrink-0"
                />
                <a
                  href="https://maps.app.goo.gl/XWrncJgXYWr4w8G36"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/80"
                >
                  Sy No 882, Plot No 117, Sai Sree Nilaya Residency,
                  Seethariguda, Hyderabad, Telangana, 501401
                </a>
              </div>

              <div className="flex gap-3">
                <LocalPhoneIcon size={20} className="flex-shrink-0" />
                <a
                  href="tel:+919848433744"
                  className="text-white/80 hover:text-white"
                >
                  +91 98484 33744
                </a>
              </div>

              <div className="flex gap-3">
                <EmailOutlinedIcon size={20} className="flex-shrink-0" />
                <a
                  href="mailto:info@slned.com"
                  className="text-white/80 hover:text-white"
                >
                  info@slned.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20 ">
        <div className="xl:max-w-screen-xl w-11/12 mx-auto py-6 flex md:flex-row flex-col gap-3 justify-between items-center">
          <p className="text-white/70 text-sm z-[2]">
            © {new Date().getFullYear()} SLN Educational Society. All Rights
            Reserved.
          </p>

          <p className="text-white/70 text-sm">
            Designed & Developed by{" "}
            <a
              href="https://novatales.com"
              target="_blank"
              rel="noreferrer noopener"
              className="hover:underline"
            >
              NovaTales
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
